import { defineMessages } from "react-intl";

export const messages = defineMessages({
    pageHomeTitle: {
        id: "pages.home.title",
        defaultMessage: "Home",
    },
    pageAlbumsTitle: {
        id: "pages.albums.title",
        defaultMessage: "Products",
    },
    pageAlbumsCreateTitle: {
        id: "pages.albums.create.title",
        defaultMessage: "Add a product",
    },
    pageTracksTitle: {
        id: "pages.tracks.title",
        defaultMessage: "Tracks",
    },
    pageArtistsTitle: {
        id: "pages.artists.title",
        defaultMessage: "Artists",
    },
    pageLoginTitle: {
        id: "pages.login.title",
        defaultMessage: "Login",
    },
    pageNotFoundTitle: {
        id: "pages.not-found.title",
        defaultMessage: "Page not found",
    },
    pageStatementsTitle: {
        id: "pages.statements.title",
        defaultMessage: "Statements",
    },
    pageReportsTitle: {
        id: "pages.reports.title",
        defaultMessage: "Reports",
    },
    pageReportsCreateTitle: {
        id: "pages.reports.create.title",
        defaultMessage: "Generate report",
    },
    pageUsersTitle: {
        id: "pages.users.title",
        defaultMessage: "Users",
    },
    pageUsersCreateTitle: {
        id: "pages.users.create.title",
        defaultMessage: "Create User",
    },
    pageDeliveriesTitle: {
        id: "pages.deliveries.title",
        defaultMessage: "Deliveries",
    },
    pageDeliveriesIntro: {
        id: "pages.deliveries.intro",
        defaultMessage: "Keep track of delivery activity across each service provider.",
    },
    pageBundlesTitle: {
        id: "pages.bundles.title",
        defaultMessage: "Bundles",
    },
    pageStatisticsTitle: {
        id: "pages.statistics.title",
        defaultMessage: "Statistics",
    },
    pageBundlesCreateTitle: {
        id: "pages.bundles.create.title",
        defaultMessage: "Upload new bundle",
    },
    pageSearchTitle: {
        id: "pages.search.title",
        defaultMessage: "Search results",
    },
    pagePlaylistsTitle: {
        id: "pages.playlists.title",
        defaultMessage: "Playlists",
    },
    welcomeUser: {
        id: "home.welcome-user",
        defaultMessage: "Welcome, {name}",
    },
    navBundlesTitle: {
        id: "nav.bundles.title",
        defaultMessage: "From bundle",
    },
    navCreateAlbumTitle: {
        id: "nav.albums.create-title",
        defaultMessage: "Add a product",
    },
    copyright: {
        id: "copyright",
        defaultMessage: "© 2025 Modulor / Watamusic",
    },
    notFoundTitle: {
        id: "not-found.title",
        defaultMessage: "404 - Page Not Found",
    },
    notFoundDescription: {
        id: "not-found.description",
        defaultMessage: "Sorry, the page you are looking for does not exist.",
    },
});
